module.exports = __webpack_public_path__ + "static/media/red_nebula_DN.940bcab8.png";